import AccountsModel from '../models/accounts.model';

let storeContent = utils.generateStore({
	entityAccounts: [],
	accountTransactions: [],
	withdrawal_types: [
		{
			name: 'Bank',
			cost: '35',
			currency_code: 'KES',
			code: 'Bank',
		},
		{
			name: 'M-PESA',
			cost: '20',
			currency_code: 'KES',
			code: 'MPESA',
		},
	],
	selected_withdrawal_type: null,
	showViewAccount: false,
	showDownloadStatement: false,
	showWithdrawalAccount: false,
	showViewPolicy: false,
	showCreateAppointment: false,
	AccountsModel,
	withdrawal_details: null,
	withdrwal_page: 1,
	selected_account: {},
	loading: false,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async viewClaim(ctx, payload) {
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'claim',
						action: 'details',
						data: {
							claim_id: payload.claim.claim_id,
						},
					},
					'/client',
				);

				ctx.commit('selectedClaim', res.result.claim_details);
				if (!payload.is_select) {
					await ctx.dispatch('fetchPendingActions');
					await ctx.dispatch('fetchClaimDocuments', payload.claim);
					await ctx.dispatch('fetchAdditionalInfo');
					ctx.commit('showClaimsModal', true);
				}

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async moveToNextReport(ctx, payload) {
			try {
				ctx.commit('loading', true);
				switch (ctx.getters.withdrwal_page) {
					case 1:
						if (await payload.ref.isValid()) {
							ctx.commit(
								'withdrawal_details',
								payload.ref.formData_,
							);
							ctx.commit('withdrwal_page', 2);
						}
						break;
					case 2:
						if (ctx.getters.selected_withdrawal_type) {
							ctx.commit('withdrwal_page', 3);
						} else {
							$notify(
								'warning',
								'Select Preffered Channel',
								`Select a withdrawal channel to continue`,
								3,
							);
						}
						break;

					default:
						ctx.commit(
							'withdrwal_page',
							ctx.getters.withdrwal_page + 1,
						);
						break;
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async moveToPreviousReport(ctx) {
			try {
				ctx.commit('loading', true);
				if (ctx.getters.withdrwal_page > 1) {
					ctx.commit(
						'withdrwal_page',
						ctx.getters.withdrwal_page - 1,
					);
				}
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async withdrawFunds(ctx) {
			try {
				ctx.commit('loading', true);

				if (ctx.getters.withdrawal_details) {
					// let res = await api.fetchEndpointSecure(
					//   {
					//     resource: 'account',
					//     action: 'get',
					//     data: {},
					//   },
					//   '/client'
					// );

					// ctx.commit('entityAccounts', res.result.client_accounts);
					$notify(
						'success',
						'Request Received',
						`Your request to withdraw ${ctx.getters.withdrawal_details.amount} was received`,
						10,
					);
					ctx.commit('withdrwal_page', 1);
					ctx.commit('withdrawal_details', null);
					ctx.commit('selected_withdrawal_type', null);
					ctx.commit('showWithdrawalAccount', false);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async downloadStatement(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					// let res = await api.fetchEndpointSecure(
					//   {
					//     resource: 'account',
					//     action: 'get',
					//     data: {},
					//   },
					//   '/client'
					// );

					// ctx.commit('entityAccounts', res.result.client_accounts);
					$notify(
						'success',
						'Downloading Statment',
						`Your request to download the statement was received`,
						5,
					);
					ctx.commit('showDownloadStatement', false);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchEntityAccounts(ctx) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'get',
						data: {},
					},
					'/client',
				);

				console.log(
					' === Client accounts ===== ',
					res.result.client_accounts,
				);
				ctx.commit('entityAccounts', res.result.client_accounts);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchAccountTransactions(ctx, payload) {
			try {
				Event.$emit('loader:show', true);
				ctx.commit('selected_account', payload.account);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'transactions',
						data: {
							account_number: payload.account.account_number,
						},
					},
					'/client',
				);

				ctx.commit('accountTransactions', res.result.transaction);

				ctx.commit('showViewAccount', true);

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
	},
};
